import React from 'react';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { Button, message } from 'antd';
import * as CONSTANT from '../../constant';
import styles from './index.less';
import getActualShareLink from './getActualShareLink';
import CustomerContext from '../CustomerContext';

const LinkPane = ({ url, hide }) => {
  const cid = React.useContext(CustomerContext);
  const finalUrl = getActualShareLink(url, cid);

  const handleOnCopy = React.useCallback(() => {
    hide();
    message.success(CONSTANT.SUCCESS_CLIPBOARD, 3);
  }, [hide]);

  return (
    <div>
      <div className={styles.row}>
        <a target="_blank" rel="noopener noreferrer" href={finalUrl}>
          {finalUrl}
        </a>
      </div>
      <div className={styles.row}>
        <CopyToClipboard text={finalUrl} onCopy={handleOnCopy}>
          <Button type="primary">
            {CONSTANT.CLIPBOARD}
          </Button>
        </CopyToClipboard>
      </div>
    </div>
  );
};

export default LinkPane;
